import React from 'react'
import { useTranslation } from 'react-i18next'
import InfoTooltip from './InfoTooltip'

const CreditStatusTooltip: React.FC = () => {
  const { t } = useTranslation()
  const indicatorText = t('tooltips.applications.creditStatusIndicator')

  return (
    <InfoTooltip
      lines={[
        t('tooltips.applications.creditStatusLine0'),
        t('tooltips.applications.creditStatusLine1')
      ]}
      indicatorText={indicatorText}
      ariaLabel='credit-status-info'
    />
  )
}

export default CreditStatusTooltip
